import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { upsertOrderInd } from "../thunks/upsertOrderInd";
import { setFetchState } from "../orderIndDataReducer";
import { OrderIndData } from "../types";

export const useOrderIndUpsert = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.trading.orderind.fetchState
  );

  const dispatch = useDispatch();
  const dispatchUpsertOrderInd = React.useCallback(
    (orderInd: OrderIndData) => dispatch(upsertOrderInd(orderInd)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchUpsertOrderInd] as [
    typeof fetchState,
    typeof dispatchUpsertOrderInd
  ];
};
